import { RestClient } from '../utils/rest-client';
import { configService } from './config.service';
const restClient = RestClient(configService.restConfig);
async function getWordSearches({ status, }) {
    const apiResponse = await restClient.get({
        openapiPath: '/word-searches',
        queryParams: {
            status,
        },
    });
    return apiResponse.body.Data.WordSearches;
}
async function createWordSearch(wordSearch) {
    const apiResponse = await restClient.post({
        openapiPath: '/word-searches',
        requestBody: {
            Data: wordSearch,
        },
    });
    return apiResponse.body.Data.WordSearch;
}
async function getWordSearchDetails(wordSearchId) {
    const apiResponse = await restClient.get({
        openapiPath: '/word-searches/{WordSearchId}',
        pathParams: {
            WordSearchId: wordSearchId,
        },
    });
    return apiResponse.body.Data.WordSearch;
}
async function updateWordSearch(wordSearchId, data) {
    const apiResponse = await restClient.put({
        openapiPath: '/word-searches/{WordSearchId}',
        pathParams: {
            WordSearchId: wordSearchId,
        },
        requestBody: {
            Data: data,
        },
    });
    return apiResponse.body.Data.WordSearch;
}
async function deleteWordSearch(wordSearchId) {
    const apiResponse = await restClient.delete({
        openapiPath: '/word-searches/{WordSearchId}',
        pathParams: {
            WordSearchId: wordSearchId,
        },
    });
    return { wordSearchId };
}
async function updateWordSearchStatus(wordSearchId, status) {
    const apiResponse = await restClient.put({
        openapiPath: '/word-searches/{WordSearchId}/status',
        pathParams: {
            WordSearchId: wordSearchId,
        },
        requestBody: {
            Data: { status },
        },
    });
    return { ...apiResponse.body.Data.WordSearch, wordSearchId };
}
async function updateWords(wordSearchId, words) {
    const apiResponse = await restClient.put({
        openapiPath: '/word-searches/{WordSearchId}/words',
        pathParams: {
            WordSearchId: wordSearchId,
        },
        requestBody: {
            Data: { words },
        },
    });
    return {
        wordSearchId,
        words: [...apiResponse.body.Data.words],
    };
}
async function getSubmissions(wordSearchId) {
    const apiResponse = await restClient.get({
        openapiPath: '/word-searches/{WordSearchId}/submissions',
        pathParams: {
            WordSearchId: wordSearchId,
        },
    });
    return apiResponse.body.Data.Submissions;
}
const wordSearchService = {
    getWordSearches,
    createWordSearch,
    getWordSearchDetails,
    updateWordSearch,
    deleteWordSearch,
    updateWordSearchStatus,
    updateWords,
    getSubmissions,
};
export { wordSearchService };
